import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap'

import TableComponent from '../../../components/shared/TableComponent';

import routes from '../../../constants/routes'
import { DialogBox } from '../../../components/shared';
import { BrokerStateMapping } from './BrokerStateMapping';

export class BrokerageList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showEditModal: false,
            selectedBrokerage : null,
            data: [],
            options: {
                defaultSortName: 'name',
                defaultSortOrder: 'asc',
                pageStartIndex: 1,
                paginationSize: 3,
                sizePerPage: 50
            },
            updateCompleted : false,
            title: ''
        };

        this.actionButtonsCellFormatter = this.actionButtonsCellFormatter.bind(this);
        this.hideEditModal = this.hideEditModal.bind(this);
        this.popupButtonsCellFormatter = this.popupButtonsCellFormatter.bind(this);
        this.updateStateObject = this.updateStateObject.bind(this);
    }

    updateStateObject (brokerId, authStates){
        var index = this.state.data.findIndex(x => x.brokerId === brokerId);
        this.state.data[index].authStates = authStates;
        this.setState({
            data: this.state.data,
            updateCompleted : true
        });
    }

    actionButtonsCellFormatter(cell, row) {
        return (
            <LinkContainer to={routes.BROKERAGE.replace(':brokerageId', row.brokerId)}>
                <Button>Manage Brokers</Button>
            </LinkContainer>
        );
    }

    popupButtonsCellFormatter (cell, row){
        return (
        <div className="updateColumn">
            <Button
            onClick={() => {
                return this.handleEditUser(row);
            }}
            >
            Assign State
            </Button>
        </div>
        );
            
    }

    handleEditUser (row) {
        this.setState({
            ...this.state,
            showEditModal: true,
            selectedBrokerage: row
          });
    }

    hideEditModal () {
        this.setState({
            ...this.state,
            showEditModal: false,
            selectedBrokerage: null,
            updateCompleted : false
          });
    }

    componentDidMount() {
        // move the pagination totals to the top of the tables
        const totals = document.querySelectorAll('.pagination-total');

        function ancestor(el, cls) {
            while ((el = el.parentElement) && !el.classList.contains(cls));
            return el;
        }

        // workaround for IE!
        Array.prototype.forEach.call(totals, el => {
            const tableContainer = ancestor(el, 'react-bs-table-container'),
                toolbar = tableContainer.querySelector('.react-bs-table-tool-bar');

            if (toolbar) toolbar.appendChild(el);
        });
    }

    componentWillReceiveProps(props) {
        this.setState({ data: props.brokerages });
    }

    generateBrokeragesTableColumns = () => {
        return [
            { dataField: 'brokerId', isKey: true, width: '0%', hidden: true },
            { dataField: 'name', title: 'Name', width: '40%', isSortable: true },
            { dataField: 'agencyCode', title: 'Agency Code', width: '10%', isSortable: true },
            { dataField: 'commission', title: 'Commission', width: '10%', isSortable: true },
            { dataField: 'state', title: 'State', width: '10%', isSortable: true },
            { dataField: 'territory', title: 'Territory', width: '15%', isSortable: true },
            { dataFormat: this.popupButtonsCellFormatter, title: 'State Mapping', width: '15%', dataAlign: 'center' },
            { dataFormat: this.actionButtonsCellFormatter, width: '15%', dataAlign: 'center' },
        ];
    }

    render() {
        return (
            <div>
                <TableComponent
                    title={this.state.title}
                    options={this.state.options}
                    data={this.state.data}
                    columns={this.generateBrokeragesTableColumns()}
                    customizedColumn = {true}
                />
                <DialogBox
                    title="Project State Mapping"
                    custom_class="State Mapping"
                    show={this.state.showEditModal}
                    onHide={this.hideEditModal}
                >
                <BrokerStateMapping                  
                  hideEditModal={this.hideEditModal}
                  authAgency={this.state.selectedBrokerage}
                  updateStateObject={this.updateStateObject}
                  updateCompleted={this.state.updateCompleted}
                />
                </DialogBox>
            </div>
        );
    }
}

BrokerageList.propTypes = {
    brokerages: PropTypes.array.isRequired,
};